import React from 'react';
import SolutionInstallmentExaminationInfoWrapper from 'components/SolutionInstallmentExaminationInfoWrapper/SolutionInstallmentExaminationInfoWrapper';

export default function SolutionInstallmentExaminationInfoContainer() {
    return (
        <SolutionInstallmentExaminationInfoWrapper />
    )
}
